export default __webpack_public_path__ + "static/media/map_justice_warriors.a8581f9c.png";